import { TicketsUrlTypeEnum } from '../../../generated/api.graphql';

/**
 * The single definition of this enum. `src/api/Announce/AnnounceDetail.ts` re-exports it
 * rather than declaring its own against the legacy generated enum — the two generated
 * `TicketsUrlTypeEnum`s share a name, members and values, so TS relates them and the legacy
 * mappers keep compiling.
 */
export const TicketsUrlType = Object.freeze({
  HANDSTAMP: TicketsUrlTypeEnum.Handstamp,
  VENUEPILOT_CHECKOUT: TicketsUrlTypeEnum.VenuepilotCheckout,
  CUSTOM: TicketsUrlTypeEnum.Custom,
  NO_URL: TicketsUrlTypeEnum.NoUrl,
});
export type TicketsUrlType = (typeof TicketsUrlType)[keyof typeof TicketsUrlType];
